'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { createRoot } from 'react-dom/client'

// lib
import App from './app'

/* -----------------------------------------------------------------------------
 * main
 * -------------------------------------------------------------------------- */

// no StrictMode yet: its double effects would repeat the session's token
// refresh and the socket's sends
createRoot(document.getElementById('root')).render(<App />)
